import React from "react";
import { PulsePopupConfirmation } from "../PulsePopupConfirmation/PulsePopupConfirmation"; // Adjust path
import { TrashcanIcon } from "../icons"; // Adjust path

interface ArchiveAppDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  appName?: string; // Optional app name for the message
  isArchiving?: boolean; // Optional loading state
  error?: string | null; // Optional error message
}

const ArchiveAppDialog: React.FC<ArchiveAppDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  appName,
  //   isArchiving = false,
  //   error,
}) => {
  const title = `Are you sure you want to archive ${appName ? `"${appName}"` : "this app"}?`;
  const description =
    "Archiving apps will make them inaccessible and cannot be restored."; // Simplified description

  return (
    <PulsePopupConfirmation
      isOpen={isOpen}
      onClose={onClose}
      icon={<TrashcanIcon />}
      title={title}
      description={description} // Pass description directly
      confirmButtonText="ARCHIVE"
      cancelButtonText="CANCEL"
      onConfirm={onConfirm}
      // Remove the invalid isLoading prop as it's not supported
      // isLoading={isArchiving}
      // Optionally display error within the dialog if needed
      // children={error ? <div className="archive-error-message">{error}</div> : null}
    />
  );
};

export default ArchiveAppDialog;
